import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import { baseColors } from "theme";

export const styles = (theme: Theme) => {
	return ({
		layout: {
			minHeight: "100vh",
			backgroundColor: baseColors.gray75,
			display: "flex",
			alignItems: "center",
			justifyContent: "center",
			padding: "2em",
		},
		container: {
			maxWidth: 600,
			textAlign: "center",
		},
		header: {
			fontSize: 96,
			fontWeight: 700,
			color: theme.palette.secondary.main,
			margin: 0,
			lineHeight: 1.1,
		},
		title: {
			fontSize: "1.25rem",
			fontWeight: 600,
			color: baseColors.darkBlack,
			margin: "12px 0 8px",
		},
		message: {
			color: baseColors.gray600,
			fontSize: "1rem",
			margin: "0 0 28px",
		},
		actions: {
			display: "flex",
			gap: 12,
			justifyContent: "center",
		},
	} satisfies Record<string, CSSObject>);
};